import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import TopNavigation from '../components/new-landing-page/TopNavigation';
import '../styles/landing.scss';
import TopBanner from '../components/new-landing-page/banner/TopBanner';
import Footer from '../components/new-landing-page/Footer';
import SecondaryFooter from '../components/new-landing-page/SecondaryFooter';
import Section from '../components/new-landing-page/sections/Section';
import Numbers from '../components/new-landing-page/sections/Numbers';
import ComparisonTable from '../components/new-landing-page/advantages/ComparisonTable';
import BulletsSection from '../components/new-landing-page/bullets-section/BulletsSection';
import Challenges from '../components/new-landing-page/challenges/Challenges';
import GetStartedSection from '../components/new-landing-page/challenges/GetStartedSection';
import UseCaseAccordion from '../components/new-landing-page/usecases/UseCaseAccordion';
import performanceEnggContent from '../content/performanceEnggContent';
const PerformanceEngg = () => {

  return (
    <Container fluid className="container-div">
      <Row>
        <Col>
          <Container>
            <TopNavigation />
          </Container>
          <TopBanner content={performanceEnggContent} />
          <Numbers />
          <Section content={performanceEnggContent.sectionContent} link={performanceEnggContent.sectionButtonLink} />
          <ComparisonTable content={performanceEnggContent.comparisonTable}/>
          <BulletsSection />
          <Challenges content={performanceEnggContent.challenges} heading={performanceEnggContent.challengesHeading} />
          <GetStartedSection content={performanceEnggContent.getStartedSection} />
          <UseCaseAccordion content={performanceEnggContent.useCases} />
          <SecondaryFooter />
          <Footer />
        </Col>
      </Row>
    </Container>
  );
};

export default PerformanceEngg;
